import { noop } from 'lodash';
import { createContext, Dispatch, SetStateAction } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

export const ClientDocumentsPageContext = createContext<{
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}>({ modalOpen: false, setModalOpen: noop });

export function useClientDocumentsPageContext() {
  return useGuardedContext(
    ClientDocumentsPageContext,
    'ClientDocumentsPageContext'
  );
}
